module.exports = __webpack_public_path__ + "static/media/user_interview_1.02697612.png";